import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import RecoveryPage from "../pages/recover-page";

import { Wrapper } from "components/apps/student-app";
import AdminPartnersPage from "components/pages/admin-partners-page";
import AdminQuestionnairesPage from "components/pages/admin/admin-questionnaires";
import AdminStatsPage from "components/pages/admin/admin-stats-app";
import ArticlesDashboardPage from "components/pages/admin/articles-dashboard-page";
import DormitoriesListPage from "components/pages/admin/dormitories-list-page";
import EventsListPage from "components/pages/admin/events-list-page";
import LabsListPage from "components/pages/admin/labs-list-page";
import UniversitiesDashboardPage from "components/pages/admin/universities-dashboard-page";
import EditDormitoryPage from "components/pages/dormitory-editor/edit-dormitory-page";
import DormitoryPublicPage from "components/pages/dormitory-public-page";
import ReviewsPage from "components/pages/reviews-page";
import EventsPublicPage from "components/pages/events-public-page";
import EventsSearchPage from "components/pages/events-search-page";
import LabPublicPage from "components/pages/lab-public-page";
import NewsArticleEditPage from "components/pages/news-article-edit-page";
import NewsArticlePage from "components/pages/news-article-page";
import NewsListPage from "components/pages/news-list-page";
import UniProfileInfoPage from "components/pages/uni-profile-info-page";
import UniversityPublicPage from "components/pages/university-public-page";
import Header from "components/tools/header";

import UniversityApi from "api/university-api";
import AdminAmbassadorsPage from "../pages/admin-ambassadors-page";
import DevPage from "../pages/dev-app";
import AmbassadorsListPage from "../pages/ambassadors-list-page";
import AmbassadorPage from "../pages/ambassador-page";
import AdminTripsPage from "../pages/admin-trips-page";
import NotificationsPage from "../pages/notifications-page";
import ClubsDashboardPage from "../pages/admin/clubs-dashboard-page";
import ClubPublicPage from "../pages/club-public-page";
import MyClubsStatsPage from "../pages/my-clubs-stats-page";

const ClubsAdminApp = () => {
    const { pathname } = useLocation();

    const isAuthPage = [`/login`, `/registration/student`, `/registration/university`].includes(pathname);

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
    }, []);

    return (
        <>
            <Wrapper>
                {!isAuthPage && <Header />}
                <Routes>

                    <Route path="/notifications" element={<NotificationsPage />} />
                    <Route path="/stats-clubs" element={<MyClubsStatsPage />} />
                    <Route path="/recover/:recoveryKey" element={<RecoveryPage />} />
                    <Route path="/universities" element={<UniversitiesDashboardPage />} />
                    <Route path="/clubs" element={<ClubsDashboardPage />} />
                    <Route path="/club/:clubId" element={<ClubPublicPage/>} />
                    <Route path="/partners" element={<AdminPartnersPage />} />
                    <Route path="/trips" element={<AdminTripsPage />} />
                    <Route path="/questionnaires" element={<AdminQuestionnairesPage />} />
                    <Route path="/articles" element={<ArticlesDashboardPage />} />
                    <Route path="/university/:universityId" element={<UniversityPublicPage />} />

                    <Route path="/ambassadors" element={<AdminAmbassadorsPage />} />

                    <Route path="/university/:universityId/edit" element={<UniProfileInfoPage />} />
                    <Route path="/dormitories" element={<DormitoriesListPage />} />
                    <Route path="/stats" element={<AdminStatsPage />} />
                    <Route path="/lab/:labId" element={<LabPublicPage />} />

                    <Route path="/ambassadors/:ambassadorId" element={<AmbassadorPage />} />
                    <Route path="/ambassadors/:ambassadorId/posts/:postId" element={<AmbassadorPage />} />

                    <Route path="/dev" element={<DevPage />} />
                    <Route path="/dormitory/:dormitoryId" element={<DormitoryPublicPage />} />
                    <Route path="/dormitory/:dormitoryId/edit" element={<EditDormitoryPage />} />
                    <Route path="/events" element={<EventsListPage />} />
                    <Route path="/events-search" element={<EventsSearchPage />} />
                    <Route path="/events/:eventId" element={<EventsPublicPage />} />
                    <Route path="/news" element={<NewsListPage />} />
                    <Route path="/news/:newsId" element={<NewsArticlePage />} />
                    <Route path="/news/create" element={<NewsArticleEditPage mode="create" />} />
                    <Route path="/news/:newsId/edit" element={<NewsArticleEditPage mode="edit" />} />
                    <Route path="/*" element={<Navigate to={`/clubs`} />} />
                </Routes>
            </Wrapper>
        </>
    );
};

export default ClubsAdminApp;
